// Shared syntax highlighting functions for code editors

const SQL_KEYWORDS = [
  'SELECT',
  'FROM',
  'WHERE',
  'AND',
  'OR',
  'NOT',
  'IN',
  'LIKE',
  'BETWEEN',
  'JOIN',
  'LEFT',
  'RIGHT',
  'INNER',
  'OUTER',
  'FULL',
  'CROSS',
  'ON',
  'GROUP',
  'BY',
  'ORDER',
  'ASC',
  'DESC',
  'HAVING',
  'LIMIT',
  'OFFSET',
  'AS',
  'DISTINCT',
  'TOP',
  'WITH',
  'UNION',
  'ALL',
  'EXISTS',
  'CASE',
  'WHEN',
  'THEN',
  'ELSE',
  'END',
  'IS',
  'NULL',
  'COUNT',
  'SUM',
  'AVG',
  'MIN',
  'MAX',
  'CAST',
  'CONVERT',
  'COALESCE',
  'ISNULL',
  'OVER',
  'PARTITION',
  'ROW_NUMBER',
  'RANK',
  'DENSE_RANK',
  'INSERT',
  'INTO',
  'VALUES',
  'UPDATE',
  'SET',
  'DELETE',
  'CREATE',
  'ALTER',
  'DROP',
  'TABLE',
  'INDEX',
  'VIEW',
  'DECLARE',
  'BEGIN',
  'EXEC',
  'EXECUTE',
];

export const highlightSQL = (code) => {
  if (!code) return '';
  let html = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  html = html.replace(/'([^']*)'/g, '<span style="color:#e5c07b">\'$1\'</span>');
  html = html.replace(/\b(\d+\.?\d*)\b/g, '<span style="color:#d19a66">$1</span>');

  const keywordPattern = new RegExp(`\\b(${SQL_KEYWORDS.join('|')})\\b`, 'gi');
  html = html.replace(
    keywordPattern,
    (match) => `<span style="color:#c678dd;font-weight:500">${match.toUpperCase()}</span>`
  );

  html = html.replace(/--(.*?)$/gm, '<span style="color:#5c6370;font-style:italic">--$1</span>');

  return html;
};

export const highlightHandlebars = (code) => {
  if (!code) return '';
  let html = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  // Comments
  html = html.replace(
    /(\{\{!--[\s\S]*?--\}\})/g,
    '<span style="color:#5c6370;font-style:italic">$1</span>'
  );
  html = html.replace(
    /(\{\{![\s\S]*?\}\})/g,
    '<span style="color:#5c6370;font-style:italic">$1</span>'
  );

  // Block helpers
  html = html.replace(
    /(\{\{[#/](?:if|each|unless|ifEquals|ifGreater|ifLess|with)[^}]*\}\})/g,
    '<span style="color:#61afef;font-weight:500">$1</span>'
  );
  html = html.replace(/(\{\{else\}\})/g, '<span style="color:#61afef;font-weight:500">$1</span>');

  // Remaining expressions
  html = html.replace(/(\{\{(?![#/!])(?:(?!\}\}).)*\}\})/g, (match) => {
    if (match.includes('style=')) return match;
    return `<span style="color:#c678dd">${match}</span>`;
  });

  return html;
};

export const highlightHTMLHandlebars = (code) => {
  if (!code) return '';
  let html = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  // Handlebars comments
  html = html.replace(
    /(\{\{!--[\s\S]*?--\}\})/g,
    '<span style="color:#5c6370;font-style:italic">$1</span>'
  );
  html = html.replace(
    /(\{\{![\s\S]*?\}\})/g,
    '<span style="color:#5c6370;font-style:italic">$1</span>'
  );

  // Handlebars block helpers
  html = html.replace(
    /(\{\{[#/](?:if|each|unless|ifEquals|ifGreater|ifLess|with)[^}]*\}\})/g,
    '<span style="color:#61afef;font-weight:500">$1</span>'
  );
  html = html.replace(/(\{\{else\}\})/g, '<span style="color:#61afef;font-weight:500">$1</span>');

  // Handlebars expressions
  html = html.replace(/(\{\{(?![#/!])(?:(?!\}\}).)*\}\})/g, (match) => {
    if (match.includes('style=')) return match;
    return `<span style="color:#c678dd">${match}</span>`;
  });

  // HTML tags
  html = html.replace(/(&lt;\/?)([\w-]+)/g, '<span style="color:#e06c75">$1$2</span>');
  html = html.replace(/([\w-]+)(=)/g, '<span style="color:#d19a66">$1</span>$2');

  // HTML comments
  html = html.replace(
    /(&lt;!--[\s\S]*?--&gt;)/g,
    '<span style="color:#5c6370;font-style:italic">$1</span>'
  );

  return html;
};
